import React, { useState } from 'react';

const GOLD = '#B8892A';
const INK = '#18140C';
const INK3 = '#7A7268';
const INK4 = '#B0A898';
const BD = '#D8D2C8';
const BG2 = '#F4F1EC';

// 生成页码序列（首页/末页固定，当前页±1，超出用省略号）
function buildPages(page, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
  const pages = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < totalPages - 1) pages.push('...');
  pages.push(totalPages);
  return pages;
}

const cellBase = {
  minWidth: 34, height: 34, padding: '0 8px', borderRadius: 6,
  border: `1px solid ${BD}`, background: '#fff', color: INK,
  fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center',
  justifyContent: 'center', fontFamily: 'var(--mono,monospace)',
};

export default function Pagination({
  page, pageSize, total, currentCount,
  onChange, onPageSizeChange, pageSizeOptions = [20, 50, 100],
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const [jump, setJump] = useState('');
  if (!total || total <= 0) return null;

  const go = (p) => {
    const n = Math.min(totalPages, Math.max(1, p));
    if (n !== page) onChange(n);
  };
  const doJump = () => {
    const n = parseInt(jump, 10);
    if (n >= 1 && n <= totalPages) { go(n); setJump(''); }
  };
  const arrow = (disabled) => ({ ...cellBase, cursor: disabled ? 'not-allowed' : 'pointer', color: disabled ? INK4 : INK, background: disabled ? BG2 : '#fff' });

  return (
    <div style={{ marginTop: 20, textAlign: 'center' }}>
      {/* 汇总 */}
      <div style={{ fontSize: 13, color: INK3, marginBottom: 12 }}>
        共 {Number(total).toLocaleString()} 条{currentCount != null ? `，本页 ${currentCount} 条` : ''}
      </div>

      {/* 页码 */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <button disabled={page <= 1} onClick={() => go(page - 1)} style={arrow(page <= 1)}>‹</button>
        {buildPages(page, totalPages).map((p, i) =>
          p === '...' ? (
            <span key={`e${i}`} style={{ minWidth: 24, textAlign: 'center', color: INK4, fontSize: 13 }}>…</span>
          ) : (
            <button
              key={p}
              onClick={() => go(p)}
              style={p === page
                ? { ...cellBase, background: GOLD, borderColor: GOLD, color: '#fff', fontWeight: 700 }
                : cellBase}
            >{p}</button>
          )
        )}
        <button disabled={page >= totalPages} onClick={() => go(page + 1)} style={arrow(page >= totalPages)}>›</button>
      </div>

      {/* 前往 + 每页条数 */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16, marginTop: 12, fontSize: 13, color: INK3, flexWrap: 'wrap' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          前往
          <input
            value={jump}
            onChange={e => setJump(e.target.value.replace(/\D/g, ''))}
            onKeyDown={e => { if (e.key === 'Enter') doJump(); }}
            onBlur={doJump}
            style={{ width: 48, height: 32, textAlign: 'center', border: `1px solid ${BD}`, borderRadius: 6, fontSize: 13, color: INK, outline: 'none' }}
          />
          页
        </span>
        {onPageSizeChange && (
          <select
            value={pageSize}
            onChange={e => onPageSizeChange(Number(e.target.value))}
            style={{ height: 32, border: `1px solid ${BD}`, borderRadius: 6, fontSize: 13, color: INK, background: '#fff', padding: '0 6px', cursor: 'pointer' }}
          >
            {pageSizeOptions.map(s => <option key={s} value={s}>{s} 条/页</option>)}
          </select>
        )}
      </div>
    </div>
  );
}
